import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productDFRCApi = createApi({
  reducerPath: "productDFRCApi",
  baseQuery,
  tagTypes: ["productDFRC"],
  endpoints: (builder) => ({
    getProductDFRC: builder.query({
      query: ({ id }) => `export/product/dfrc/${id}`,
      transformResponse: (response) => {
        return response?.data[0] ?? [];
      },
      providesTags: ["productDFRC"],
    }),

    createProductDFRC: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/product/dfrc/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { ExportProductDfrc: data },
      }),
      invalidatesTags: ["productDFRC"],
    }),


    createProductDFRCTable: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/product/sion/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductSion: data },
      }),
      invalidatesTags: ["productDFRC"],
    }),

    updateProductDFRCTable: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `export/product/sion/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductSion: data },
      }),
      invalidatesTags: ["productDFRC"],
    }),

    deleteProductDFRCTable: builder.mutation({
      query: ({ id }) => ({
        url: `export/product/sion/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["productDFRC"],
    }),

    getProductDFRCTable: builder.query({
      query: ({ id }) => `export/product/sion/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];

        return normalized.map((item) => ({
          ...item,
          id: item.sionId,
        }));
      },
      providesTags: ["productDFRC"],
    }),
  }),
});

export const {
  useLazyGetProductDFRCQuery,
  useCreateProductDFRCMutation,
  useUpdateProductDFRCMutation,
  useCreateProductDFRCTableMutation,
  useLazyGetProductDFRCTableQuery,
  useUpdateProductDFRCTableMutation,
  useDeleteProductDFRCTableMutation,
} = productDFRCApi;
